import React from "react";
import { Button } from "@/components/ui/button";

/**
 * Past-due payment banner shown at the top of the member dashboard.
 *
 * Extracted verbatim from src/pages/Dashboard.jsx during the code-quality pass:
 * markup, copy, data-testids and behaviour are unchanged.
 */
export default function PastDueBanner({ onUpdatePayment, onSeeFreeOptions }) {
  return (
    <div
      data-testid="past-due-banner"
      className="mt-5 rounded-2xl bg-[#FBF0DC] border border-[#E7CF9E] p-5"
    >
      <h2 className="font-display text-lg font-bold text-[#8A5A12]">
        We could not process your last payment
      </h2>
      <p className="mt-1.5 text-sm text-[#8A5A12] leading-6">
        Your recovery connections are still here. Update your payment method to keep unlimited
        messaging, or use the free Recovery Access Pass if money is tight right now.
      </p>
      <div className="mt-3 flex flex-wrap gap-2">
        <Button
          onClick={onUpdatePayment}
          data-testid="past-due-update-payment"
          className="bg-[#D07A4A] hover:bg-[#B96536] text-white"
        >
          Update payment method
        </Button>
        <Button
          variant="outline"
          onClick={onSeeFreeOptions}
          className="bg-white border-[#E7CF9E] text-[#8A5A12]"
        >
          See free access options
        </Button>
      </div>
    </div>
  );
}
